export default __webpack_public_path__ + "static/media/animationSuccess.0af22f16.gif";